import React, { ReactNode } from 'react'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'
import { FluidObject } from 'gatsby-image'

interface WallpaperProps {
	fluid: FluidObject,
	className?: string,
	backgroundColor?: string,
	children?: ReactNode
}

export const BaseWallpaper = ({
	fluid,
	className,
	backgroundColor,
	children
}: WallpaperProps) => {

	return (
		<BackgroundImage
			Tag="div"
			className={className}
			fluid={fluid}
			fadeIn={true}
			backgroundColor={backgroundColor}

		>
			{children}
		</BackgroundImage>
	)
}

interface BaseProps{
	tileSize? : string
}
export default styled(BaseWallpaper)<BaseProps>`
	height: 100%;
	width: 100%;
	
	background-size: contain;
	background-repeat: repeat;
	/* Remove flashing images */
	transform: translate3d(0px, 0px, 1px);

	background-size: ${({tileSize}) => tileSize};
`